import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerTargetDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    container: {
        pointerEvents: "none",
        position: "absolute"
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    colors,
    spaces
}: MessageScrollerTargetDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: colors.system.state.overlay.hover.default,
            ...getCornerStyle({
                radius: radiuses.surface + spaces.spacingSm,
                shapeConfigs
            }),
            zIndex: shapeConfigs.layers.base - 1,
            bottom: -spaces.spacingXs,
            start: -spaces.spacingSm,
            end: -spaces.spacingSm,
            top: -spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
